// Fire-and-forget analytics recording -- never rethrows, since a failed record
// must not block save/navigation for the page that's actually doing real work.

import axios from 'axios'
import { PageFocusEvent } from '@/models/PageFocusEvent'

export class PageFocusEventService {
    static record(event: PageFocusEvent): void {
        axios.post('/PageFocusEvent', event).catch((error) => {
            console.warn('Failed to record page focus time', error)
        })
    }
}

export default PageFocusEventService
